<span class="badge {{ClassName}}" title="marktwaarde">
  {{ marketValue() | marketValueConverter }}
</span>